var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNoData = function SvgIconNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356,
    height: 247,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__a)",
    d: "M253.066 49.441c0 25.97-20.652 47.444-46.342 48.942h-3.023c-8.563 0-17.126-2.497-24.178-6.492-15.112-8.49-25.186-24.47-25.186-42.949 0-12.485 4.533-23.972 12.593-32.462C175.997 6.492 189.094 0 203.701 0c19.142 0 35.765 10.987 43.824 26.968 3.526 6.992 5.541 14.483 5.541 22.473Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M252.633 49.438c0 25.97-20.653 47.444-46.342 48.942-9.571-1.498-18.638-3.995-27.201-5.993-15.112-8.49-25.186-24.47-25.186-42.949 0-12.485 4.533-23.972 12.593-32.462 16.623-.499 35.764 1 55.409 4.495 9.067 1.498 17.63 3.496 25.69 5.494 3.022 6.991 5.037 14.482 5.037 22.473Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__b)",
    d: "M312.863 82.492c3.801-21.18-43.073-47.164-104.697-58.037C146.542 13.583 93.504 21.94 89.702 43.12c-3.802 21.18 43.073 47.164 104.697 58.036 61.624 10.873 114.662 2.517 118.464-18.663Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M192.456 36.54c.28-3.575-5.338-6.923-12.55-7.48-7.211-.555-13.285 1.892-13.565 5.467-.28 3.575 5.339 6.924 12.55 7.48 7.211.555 13.285-1.892 13.565-5.467ZM129.075 45.728c6.933-2.04 11.72-6.482 10.691-9.919-1.03-3.437-7.485-4.569-14.419-2.528-6.933 2.041-11.72 6.482-10.69 9.92 1.029 3.436 7.484 4.568 14.418 2.527ZM243.398 49.69c.634-3.53-4.625-7.41-11.746-8.667-7.121-1.257-13.408.587-14.041 4.117-.634 3.53 4.625 7.41 11.746 8.666 7.121 1.257 13.407-.587 14.041-4.117ZM281.638 75.803c1.657-3.187-2.211-8.434-8.639-11.721-6.429-3.287-12.984-3.367-14.642-.18-1.657 3.186 2.211 8.434 8.639 11.72 6.429 3.287 12.984 3.368 14.642.181Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__c)",
    d: "m195.001 67.32-47.35-.5-67.432 125.424 189.266 19.904L248.395 84.3l-53.394-16.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__d)",
    d: "M294.225 245.52H51.935c6.549-5.868 16.12-11.737 27.201-16.139 6.045-2.201 13.097-5.135 20.15-6.602 21.155-5.869 46.845-9.537 74.046-9.537 32.742 0 62.965 5.135 86.136 13.205 8.06 2.934 15.112 5.869 21.156 9.537 5.541 2.934 10.075 5.868 13.601 9.536Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__e)",
    d: "M102.64 226.339c.318 2.979-4.875 6.546-10.885 7.186-6.011.64-11.284-1.309-12.103-4.235 5.852-2.13 12.653-4.864 19.56-6.604 2.109.78 3.27 2.163 3.428 3.653Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__f)",
    d: "M145.124 224.226c8.068 0 14.608-1.565 14.608-3.496 0-1.93-6.54-3.496-14.608-3.496-8.068 0-14.608 1.566-14.608 3.496 0 1.931 6.54 3.496 14.608 3.496Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__g)",
    d: "M223.864 223.946c.165-2.477-6.226-4.913-14.276-5.442-8.05-.529-14.71 1.05-14.876 3.527-.165 2.477 6.226 4.913 14.276 5.442 8.05.529 14.71-1.05 14.876-3.527Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__h)",
    d: "M279.322 235.197c-2.002-.231-4.405-.153-7.35-.996-7.95-1.419-14.169-4.65-13.883-7.131.057-.496.057-.496.615-.934 7.778 2.908 14.847 5.72 20.618 9.061Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__i)",
    d: "M248.094 85.586c1.706-9.504-19.558-21.204-47.494-26.133-27.937-4.929-51.966-1.22-53.672 8.284-1.706 9.504 19.558 21.204 47.494 26.133 27.936 4.929 51.966 1.22 53.672-8.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED7E2",
    d: "M67.209 131.625s-17.4 4.418-12.128 7.952c5.273 3.358 17.752 9.189 29.528 5.301 11.776-3.887 0-9.365.175-9.365.176 0-17.575-3.888-17.575-3.888Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EEF8",
    d: "M45.942 130.209c6.327 1.944 25.836-1.236 38.315-9.365 9.843 12.193 13.533 15.374 17.049 15.727-5.449 5.478-23.552 14.314-33.746 2.828-11.951 7.598-21.618-9.19-21.618-9.19ZM254.935 146.122c6.678.354 24.781-7.775 34.624-18.731 12.654 9.365 16.873 11.486 20.563 10.956-4.042 6.715-16.345 21.382-33.745 22.442-12.655-7.422-21.442-14.667-21.442-14.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M197.053 146.334c-1.321-6.556-13.703-22.064-26.766-28.867 5.919-14.589 6.922-19.202 5.489-22.644 7.51 2.242 24.78 10.504 30.141 27.091-4.036 14.104-8.864 24.42-8.864 24.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D5DAE8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M354.069 245.531H1.932"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__j)",
    d: "M84.864 165.273V206h-9.228l-14.715-21.398h-.24V206H49.626v-40.727h9.386l14.478 21.318h.318v-21.318h11.057Zm46.364 20.363c0 4.534-.881 8.359-2.645 11.475-1.763 3.102-4.143 5.455-7.139 7.059-2.996 1.591-6.337 2.387-10.023 2.387-3.712 0-7.066-.802-10.062-2.406-2.983-1.618-5.356-3.978-7.12-7.08-1.75-3.116-2.624-6.927-2.624-11.435 0-4.534.875-8.352 2.625-11.454 1.763-3.116 4.136-5.469 7.119-7.06 2.996-1.604 6.35-2.406 10.062-2.406 3.686 0 7.027.802 10.023 2.406 2.996 1.591 5.376 3.944 7.139 7.06 1.764 3.102 2.645 6.92 2.645 11.454Zm-11.375 0c0-2.439-.325-4.494-.974-6.164-.636-1.684-1.584-2.957-2.844-3.819-1.246-.875-2.784-1.312-4.614-1.312-1.829 0-3.374.437-4.633 1.312-1.246.862-2.194 2.135-2.844 3.819-.636 1.67-.954 3.725-.954 6.164 0 2.44.318 4.501.954 6.185.65 1.67 1.598 2.943 2.844 3.818 1.259.862 2.804 1.293 4.633 1.293 1.83 0 3.368-.431 4.614-1.293 1.26-.875 2.208-2.148 2.844-3.818.649-1.684.974-3.745.974-6.185ZM166.531 206H150.86v-40.727h15.512c4.189 0 7.808.815 10.858 2.446 3.062 1.617 5.422 3.951 7.079 7 1.671 3.036 2.506 6.675 2.506 10.917 0 4.243-.829 7.889-2.486 10.938-1.657 3.036-4.004 5.369-7.04 7-3.036 1.617-6.622 2.426-10.758 2.426Zm-4.614-9.386h4.216c2.015 0 3.732-.325 5.151-.975 1.431-.649 2.519-1.77 3.261-3.361.756-1.591 1.133-3.805 1.133-6.642s-.384-5.051-1.153-6.642c-.756-1.591-1.869-2.711-3.341-3.36-1.458-.65-3.248-.975-5.369-.975h-3.898v21.955ZM201.62 206h-11.932l13.443-40.727h15.114L231.688 206h-11.932l-8.909-29.511h-.318L201.62 206Zm-2.227-16.068h22.431v8.273h-22.431v-8.273Zm31.643-15.75v-8.909h35.398v8.909h-12.25V206h-10.898v-31.818h-12.25ZM277.714 206h-11.932l13.444-40.727h15.113L307.782 206h-11.931l-8.909-29.511h-.319L277.714 206Zm-2.227-16.068h22.432v8.273h-22.432v-8.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-no-data_svg__k)",
    d: "M79.864 165.273V206h-9.228l-14.715-21.398h-.24V206H44.626v-40.727h9.386l14.478 21.318h.318v-21.318h11.057Zm46.364 20.363c0 4.534-.881 8.359-2.645 11.475-1.763 3.102-4.143 5.455-7.139 7.059-2.996 1.591-6.337 2.387-10.023 2.387-3.712 0-7.066-.802-10.062-2.406-2.983-1.618-5.356-3.978-7.12-7.08-1.75-3.116-2.624-6.927-2.624-11.435 0-4.534.875-8.352 2.625-11.454 1.763-3.116 4.136-5.469 7.119-7.06 2.996-1.604 6.35-2.406 10.062-2.406 3.686 0 7.027.802 10.023 2.406 2.996 1.591 5.376 3.944 7.139 7.06 1.764 3.102 2.645 6.92 2.645 11.454Zm-11.375 0c0-2.439-.325-4.494-.974-6.164-.636-1.684-1.584-2.957-2.844-3.819-1.246-.875-2.784-1.312-4.614-1.312-1.829 0-3.374.437-4.633 1.312-1.246.862-2.194 2.135-2.844 3.819-.636 1.67-.954 3.725-.954 6.164 0 2.44.318 4.501.954 6.185.65 1.67 1.598 2.943 2.844 3.818 1.259.862 2.804 1.293 4.633 1.293 1.83 0 3.368-.431 4.614-1.293 1.26-.875 2.208-2.148 2.844-3.818.649-1.684.974-3.745.974-6.185ZM161.531 206H145.86v-40.727h15.512c4.189 0 7.808.815 10.858 2.446 3.062 1.617 5.422 3.951 7.079 7 1.671 3.036 2.506 6.675 2.506 10.917 0 4.243-.829 7.889-2.486 10.938-1.657 3.036-4.004 5.369-7.04 7-3.036 1.617-6.622 2.426-10.758 2.426Zm-4.614-9.386h4.216c2.015 0 3.732-.325 5.151-.975 1.431-.649 2.519-1.77 3.261-3.361.756-1.591 1.133-3.805 1.133-6.642s-.384-5.051-1.153-6.642c-.756-1.591-1.869-2.711-3.341-3.36-1.458-.65-3.248-.975-5.369-.975h-3.898v21.955ZM196.62 206h-11.932l13.443-40.727h15.114L226.688 206h-11.932l-8.909-29.511h-.318L196.62 206Zm-2.227-16.068h22.431v8.273h-22.431v-8.273Zm31.643-15.75v-8.909h35.398v8.909h-12.25V206h-10.898v-31.818h-12.25ZM272.714 206h-11.932l13.444-40.727h15.113L302.782 206h-11.931l-8.909-29.511h-.319L272.714 206Zm-2.227-16.068h22.432v8.273h-22.432v-8.273Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__a",
    x1: 203.709,
    x2: 203.709,
    y1: 3.418,
    y2: 58.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__b",
    x1: 97.455,
    x2: 222.646,
    y1: 44.48,
    y2: 66.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D6DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__c",
    x1: 174.864,
    x2: 174.864,
    y1: 71.869,
    y2: 153.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC4D1",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7CB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__d",
    x1: 173.08,
    x2: 173.08,
    y1: 213.242,
    y2: 245.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838DA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__e",
    x1: 90.735,
    x2: 91.329,
    y1: 223.938,
    y2: 229.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__f",
    x1: 145.126,
    x2: 145.126,
    y1: 217.477,
    y2: 221.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__g",
    x1: 195.725,
    x2: 212.086,
    y1: 222.097,
    y2: 223.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__h",
    x1: 269.188,
    x2: 268.756,
    y1: 227.58,
    y2: 231.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__i",
    x1: 197.511,
    x2: 204.966,
    y1: 89.943,
    y2: 64.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__j",
    x1: 178.521,
    x2: 178.521,
    y1: 146.918,
    y2: 194.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CBDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-no-data_svg__k",
    x1: 173.521,
    x2: 173.521,
    y1: 146.918,
    y2: 194.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4DAE4"
  })))));
};
export default SvgIconNoData;